export default "__VITE_ASSET__Cx8pzBAO__"